/**
 * @generated SignedSource<<3e8bb46a368a5642cbd5493670ad4dcd>>
 * @relayHash b78693201b09e246fa9be8446fcd39dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ead88b3527476795f4232ca5ce211415ac30cb2b7bdbe3bb27b75a8c534d5091

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cascadingSelect_issueFieldCascadingSelect_PrefetchQuery$variables = {
  id: string;
};
export type cascadingSelect_issueFieldCascadingSelect_PrefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment">;
};
export type cascadingSelect_issueFieldCascadingSelect_PrefetchQuery = {
  response: cascadingSelect_issueFieldCascadingSelect_PrefetchQuery$data;
  variables: cascadingSelect_issueFieldCascadingSelect_PrefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "value"
},
v6 = {
  "kind": "ScalarField",
  "name": "isDisabled"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelect_PrefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cascadingSelect_issueFieldCascadingSelect_PrefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraParentOptionConnection",
                "kind": "LinkedField",
                "name": "parentOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraParentOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraParentOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "JiraOptionConnection",
                            "kind": "LinkedField",
                            "name": "childOptions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraOption",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "parentOptions(first:100,searchBy:\"\")"
              },
              {
                "args": (v3/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_parentOptions",
                "kind": "LinkedHandle",
                "name": "parentOptions"
              }
            ],
            "type": "JiraCascadingSelectField"
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "ead88b3527476795f4232ca5ce211415ac30cb2b7bdbe3bb27b75a8c534d5091",
    "metadata": {},
    "name": "cascadingSelect_issueFieldCascadingSelect_PrefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "67e48e7997da78e44b6f85bf56f66d6c";

export default node;
